var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',_vm._b({directives:[{name:"ripple",rawName:"v-ripple"}],on:{"click":function($event){_vm.$emit('click')}}},'v-flex',( _obj = {}, _obj[_vm.size] = _vm.size !== '', _obj ),false),[_c('v-btn',{staticClass:"text-xs-center bordered",attrs:{"flat":"","block":"","ripple":false}},[_vm._t("default")],2)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa616ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat_center_v2/ModalBtn.vue
// module id = null
// module chunks = 